import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from './context/CartContext';

const BottomNavBar = () => {
  const location = useLocation();
  const { cartCount, setCheckoutDrawerOpen, setCartOpen } = useCart();

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css';
    link.id = 'fa-cdn';
    if (!document.getElementById('fa-cdn')) document.head.appendChild(link);
    
  }, []);
  const handleNavClick = () => {
    setCheckoutDrawerOpen(false); 
    setCartOpen(false); 
  };

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { path: '/',         icon: 'fa-solid fa-house',          label: 'Home'    },
    { path: '/cart',     icon: 'fa-solid fa-bag-shopping',   label: 'Cart',   badge: cartCount },
    { path: '/dashboard',icon: 'fa-solid fa-user',           label: 'Account' },
    { path: '/contactUs',icon: 'fa-solid fa-headset',        label: 'Support' },
  ];

  return (
    <>
      <style>{`
        .bnb-wrap {
          display: none;
        }

        @media (max-width: 768px) {
          .bnb-wrap {
            display: flex;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 99999;
            background: #ffffff;
            border-top: 1.5px solid #d4edda;
            padding: 8px 0 env(safe-area-inset-bottom, 8px);
            justify-content: space-around;
            align-items: center;
            box-shadow: 0 -4px 20px rgba(37, 160, 80, 0.1);
          }

          .bnb-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 3px;
            text-decoration: none;
            padding: 4px 16px;
            border-radius: 14px;
            transition: background 0.18s ease;
            position: relative;
            flex: 1;
          }

          .bnb-item:active {
            background: #e8f5e9;
          }

          .bnb-icon-wrap {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            transition: background 0.18s ease, transform 0.18s ease;
          }

          .bnb-item.active .bnb-icon-wrap {
            background: #e8f5e9;
            transform: translateY(-2px);
          }

          .bnb-item i {
            font-size: 19px;
            color: #9e9e9e;
            transition: color 0.18s ease;
          }

          .bnb-item.active i {
            color: #2e7d32;
          }

          .bnb-label {
            font-size: 10px;
            font-weight: 500;
            color: #9e9e9e;
            letter-spacing: 0.2px;
            transition: color 0.18s ease;
            font-family: 'DM Sans', sans-serif;
          }

          .bnb-item.active .bnb-label {
            color: #2e7d32;
            font-weight: 600;
          }

          .bnb-badge {
            position: absolute;
            top: -2px;
            right: -4px;
            min-width: 16px;
            height: 16px;
            background: #25D366;
            color: #fff;
            font-size: 9px;
            font-weight: 700;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 4px;
            border: 1.5px solid #fff;
            font-family: 'DM Sans', sans-serif;
          }

          .bnb-active-bar {
            position: absolute;
            top: -1px;
            left: 50%;
            transform: translateX(-50%);
            width: 28px;
            height: 3px;
            background: #2e7d32;
            border-radius: 0 0 4px 4px;
            opacity: 0;
            transition: opacity 0.18s ease;
          }

          .bnb-item.active .bnb-active-bar {
            opacity: 1;
          }

          
        }
      `}</style>

      <nav className="bnb-wrap" role="navigation" aria-label="Bottom navigation">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`bnb-item${isActive(item.path) ? ' active' : ''}`}
            aria-label={item.label}
            onClick={handleNavClick}
          >
            <div className="bnb-active-bar" />
            <div className="bnb-icon-wrap">
              <i className={item.icon} />
              {item.badge > 0 && (
                <span className="bnb-badge">{item.badge > 99 ? '99+' : item.badge}</span>
              )}
            </div>
            <span className="bnb-label">{item.label}</span>
          </Link>
        ))}
      </nav>
    </>
  );
};

export default BottomNavBar;